import { render, staticRenderFns } from "./MemberVotingDashboard.vue?vue&type=template&id=bf048c94&scoped=true"
import script from "./MemberVotingDashboard.vue?vue&type=script&lang=js"
export * from "./MemberVotingDashboard.vue?vue&type=script&lang=js"
import style0 from "./MemberVotingDashboard.vue?vue&type=style&index=0&id=bf048c94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf048c94",
  null
  
)

export default component.exports